import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
    admins: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/admins').then(response => {
			commit(types.STORE_ADMINS, response.data);

			return response.data;
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/admins/${id}`).then(response => {
			commit(types.STORE_ONE_ADMIN, response.data);

			return response.data;
		});
    },
	
	create({commit}, {fullname, username, password, roles}) {
		return axios.post('/api/admins', {
			fullname,
			username,
			password,
			roles
		}).then(response => {
			commit(types.STORE_ONE_ADMIN, response.data);

			return response.data;
		});
	},

	update({commit}, {id, fullname, username, password, roles}) {
		return axios.put(`/api/admins/${id}`, {
			fullname,
			username,
			password,
			roles
		}).then(response => {
			commit(types.STORE_ONE_ADMIN, response.data);

			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/admins/${id}`).then(() => {
			commit(types.DELETE_ADMIN, id);
		});
	}
};

const mutations = {
	[types.STORE_ADMINS](state, admins) {
		state.admins = unionState(state.admins, admins);
    },

    [types.STORE_ONE_ADMIN](state, admin) {
		state.admins = unionState(state.admins, [admin]);
    },

    [types.DELETE_ADMIN](state, id) {
        state.admins = state.admins.filter(c => c.id != id);
	},
};

const getters = {
	getById: state => id => state.admins.find(f => f.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};